import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ModalProvider } from './contexts/ModalContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClienteDetalhe from './pages/ClienteDetalhe';
import Servicos from './pages/Servicos';
import ServicoForm from './pages/ServicoForm';
import ServicoDetalhe from './pages/ServicoDetalhe';
import Historico from './pages/Historico';
import Configuracoes from './pages/Configuracoes';
import Checkin from './pages/Checkin';
import DashboardFinanceiro from './pages/DashboardFinanceiro';
import Alertas from './pages/Alertas';
import Oficinas from './pages/Oficinas';
import TrocarSenhaObrigatoria from './pages/TrocarSenhaObrigatoria';

// Garante que toda navegação (inclusive "Ver OS completa") abra no topo da página
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RotaProtegida({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/login" />;
}

function RotaAdmin({ children }) {
  const { usuario, isAdmin } = useAuth();
  if (!usuario) return <Navigate to="/login" />;
  if (!isAdmin) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  const { usuario, isSuperAdmin } = useAuth();

  // 1º acesso com senha padrão (proprietario/mecânico provisionado pelo super-admin):
  // bloqueia qualquer rota até o usuário definir uma senha própria.
  if (usuario && usuario.trocarSenhaObrigatoria) {
    return <TrocarSenhaObrigatoria />;
  }

  // Super-admin (dono da plataforma) tem experiência própria: gerencia oficinas
  // e não acessa as telas de loja.
  if (usuario && isSuperAdmin) {
    return (
      <Routes>
        <Route path="/admin/oficinas" element={<Oficinas />} />
        <Route path="*" element={<Navigate to="/admin/oficinas" />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={usuario ? <Navigate to="/" /> : <Login />} />
      <Route path="/recuperar-senha" element={usuario ? <Navigate to="/" /> : <RecuperarSenha />} />
      <Route path="/*" element={
        <RotaProtegida>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/clientes/:id" element={<ClienteDetalhe />} />
              <Route path="/servicos" element={<Servicos />} />
              <Route path="/servicos/novo" element={<ServicoForm />} />
              <Route path="/servicos/:id" element={<ServicoDetalhe />} />
              <Route path="/historico/:veiculoId" element={<Historico />} />
              <Route path="/checkin/:servicoId" element={<Checkin />} />
              <Route path="/configuracoes" element={<RotaAdmin><Configuracoes /></RotaAdmin>} />
              <Route path="/financeiro" element={<RotaAdmin><DashboardFinanceiro /></RotaAdmin>} />
              <Route path="/alertas" element={<RotaAdmin><Alertas /></RotaAdmin>} />
            </Routes>
          </Layout>
        </RotaProtegida>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ScrollToTop />
          <ModalProvider>
            <AppRoutes />
          </ModalProvider>
          <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
